"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterSplittingPlant = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var WaterSplittingPlant = (function (_super) {
    __extends(WaterSplittingPlant, _super);
    function WaterSplittingPlant() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.WATER_SPLITTING_PLANT,
            tags: [Tags_1.Tags.BUILDING],
            cost: 12,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oceans(2); }),
            metadata: {
                cardNumber: '177',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 3 Energy to raise oxygen 1 step.', function (eb) {
                        eb.energy(3).startAction.oxygen(1);
                    });
                }),
                description: 'Requires 2 ocean tiles.',
            },
        }) || this;
    }
    WaterSplittingPlant.prototype.play = function () {
        return undefined;
    };
    WaterSplittingPlant.prototype.canAct = function (player) {
        return player.energy >= 3 && player.canAfford(0, { tr: { oxygen: 1 } });
    };
    WaterSplittingPlant.prototype.action = function (player) {
        player.energy -= 3;
        return player.game.increaseOxygenLevel(player, 1);
    };
    return WaterSplittingPlant;
}(Card_1.Card));
exports.WaterSplittingPlant = WaterSplittingPlant;
